// src/components/Calendar/EventDetailModal.jsx
import React from 'react';
import { X, MapPin, Trash2, CalendarClock } from 'lucide-react';
import { getEventStyle } from '../../lib/eventTypes';
import { formatEventSchedule } from '../../utils/ministryDates';

const EventDetailModal = ({ event, onClose, isAdmin, onDelete }) => {
    if (!event) return null;
    const style = getEventStyle(event.type);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-purple-950/60 p-3 backdrop-blur-sm sm:p-4" onClick={onClose}>
            <div className="max-h-[90vh] w-full max-w-md overflow-y-auto rounded-2xl bg-white shadow-2xl" onClick={(e) => e.stopPropagation()}>
                {/* Banner — event image if present, else a typed color block */}
                {event.imageUrl ? (
                    <div className="relative h-52 w-full">
                        <img src={event.imageUrl} alt={event.title} className="h-full w-full object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/10" />
                        <button aria-label="Close event" onClick={onClose} className="absolute right-4 top-4 grid h-8 w-8 place-items-center rounded-full bg-black/40 text-white backdrop-blur-sm transition-all hover:rotate-90 hover:bg-black/60">
                            <X className="h-4 w-4" />
                        </button>
                        <div className="absolute inset-x-0 bottom-0 p-5">
                            <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide text-white ${style.solid}`}>
                                {event.type || 'general'}
                            </span>
                            <h3 className="mt-2 font-display text-2xl font-semibold leading-tight text-white">{event.title}</h3>
                        </div>
                    </div>
                ) : (
                    <div className={`relative px-6 py-5 ${style.solid}`}>
                        <button aria-label="Close event" onClick={onClose} className="absolute right-4 top-4 grid h-8 w-8 place-items-center rounded-full bg-white/20 text-white transition-all hover:rotate-90 hover:bg-white/30">
                            <X className="h-4 w-4" />
                        </button>
                        <span className="inline-block rounded-full bg-white/20 px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide text-white">
                            {event.type || 'general'}
                        </span>
                        <h3 className="mt-2 font-display text-2xl font-semibold leading-tight text-white">{event.title}</h3>
                    </div>
                )}

                <div className="space-y-4 p-6">
                    <div className="flex items-center gap-2.5 text-gray-700">
                        <CalendarClock className="h-4 w-4 flex-shrink-0 text-purple-500" />
                        <span className="text-sm">
                            {formatEventSchedule(event)}
                            <span className="block text-xs text-gray-500">Antigua time (AST)</span>
                        </span>
                    </div>
                    {event.location && (
                        <div className="flex items-center gap-2.5 text-gray-700">
                            <MapPin className="h-4 w-4 flex-shrink-0 text-purple-500" />
                            <span className="text-sm">{event.location}</span>
                        </div>
                    )}
                    {event.description && (
                        <div className="rounded-xl bg-gray-50 p-4">
                            <p className="whitespace-pre-wrap text-sm leading-relaxed text-gray-600">{event.description}</p>
                        </div>
                    )}
                    {isAdmin && (
                        <button
                            onClick={() => { if (window.confirm('Delete this event?')) { onDelete(event.id); onClose(); } }}
                            className="flex w-full items-center justify-center gap-2 rounded-lg bg-red-50 px-4 py-2.5 font-semibold text-red-600 transition-colors hover:bg-red-100"
                        >
                            <Trash2 className="h-4 w-4" />
                            Delete Event
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EventDetailModal;
